import { Component, ElementRef, EventEmitter, Input, Optional, Output, Self, ViewChild } from '@angular/core';
import { FormControlDirective, NgControl } from '@angular/forms';
import { trigger } from '@angular/animations';
import { ControlValueAccessorProxy } from '@trilean/tr3';
import { fadeInOut, expandShrinkWidthConstHeight } from '@trilean/tr3/animations';
import { ExpandableContentPosition } from '../expandable-filter/expandable-filter.component';
import { CanColor, CanColorCtor, CanDisable, CanDisableCtor, mixinColor, mixinDisabled } from '@angular/material/core';
import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';

// Boilerplate for applying mixins.
class ComponentBase extends ControlValueAccessorProxy {
  constructor(ngControl: NgControl, public _elementRef: ElementRef) {
    super(ngControl);
  }
}

const _ComponentMixinBase: CanColorCtor & CanDisableCtor & typeof ComponentBase = mixinColor(
  mixinDisabled(ComponentBase),
);

@Component({
  selector: 'tr3-expandable-search',
  templateUrl: './expandable-search.component.html',
  styleUrls: ['./expandable-search.component.scss'],
  inputs: ['disabled', 'color'],
  animations: [trigger('animWidth', expandShrinkWidthConstHeight({ delay: 250 })), trigger('fadeInOut', fadeInOut())],
})
export class ExpandableSearchComponent extends _ComponentMixinBase implements CanColor, CanDisable {
  constructor(@Optional() @Self() ngControl: NgControl, elementRef: ElementRef) {
    super(ngControl, elementRef);
  }

  @Input()
  get open(): boolean {
    return this._open;
  }
  set open(v: boolean) {
    this._open = coerceBooleanProperty(v);
  }
  private _open = false;
  static ngAcceptInputType_open: BooleanInput;

  @Output() openChange = new EventEmitter<boolean>();

  @Input() tooltip?: string;

  @Input() placeholder = '';

  @Input() contentPosition: ExpandableContentPosition = 'before';

  @Input()
  get showBack(): boolean {
    return this._showBack;
  }
  set showBack(v: boolean) {
    this._showBack = coerceBooleanProperty(v);
  }

  private _showBack = true;
  static ngAcceptInputType_showBack: BooleanInput;

  set disabled(v: boolean) {
    super.disabled = v;
    if (this.disabled) {
      this.setOpen(false);
    }
  }
  static ngAcceptInputType_disabled: BooleanInput;

  @ViewChild(FormControlDirective)
  set formControlDirective(fcd: FormControlDirective | undefined) {
    super.formControlDirective = fcd;
  }

  setOpen(v: boolean): void {
    if (v == this.open) return;
    this.open = v;
    this.openChange.emit(v);
    if (!v) this.ngControl.reset('');
  }

  onFocusOut(): void {
    if (!this.ngControl.value) this.setOpen(false);
  }
}
